import { render } from "./CrudDemo.vue?vue&type=template&id=1cc5da1c&scoped=true"
import script from "./CrudDemo.vue?vue&type=script&lang=js"
export * from "./CrudDemo.vue?vue&type=script&lang=js"

import "./CrudDemo.vue?vue&type=style&index=0&id=1cc5da1c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc5da1c"]])

export default __exports__